import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISiteScimConfiguration } from '../types/ISiteScimConfiguration';

export interface IGetSiteScimConfigurationParams {
}

export class GetSiteScimConfigurationRequest extends Request<IGetSiteScimConfigurationParams, ISiteScimConfiguration> {
  constructor() {
    super('getSiteScimConfiguration', null);
  }
}
